<template>
  <v-card>
    <QueueDetailsDialog ref="detailsDialog" />

    <v-toolbar class="card-bar">
      <v-toolbar-title>Filas</v-toolbar-title>
      <v-spacer />
      <v-btn icon @click="reload">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-toolbar>

    <ODataGrid
      v-if="gridData != null"
      class="report-grid dense-table"
      :data="gridData"
      :limits="limits"
      :limit.sync="limit"
      :offset.sync="offset"
      @rowClicked="showRowDetails"
    />
  </v-card>
</template>

<script>
import { go } from '@/models'
import grid from 'oderon-commons/src/grid'
import { preProcessSpec } from 'oderon-commons/src/tables'
import ODataGrid from 'oderon-vue/cpts/ODataGrid.vue'
import utils from 'oderon-commons/src/utils'
import QueueDetailsDialog from '../queues/QueueDetailsDialog.vue'

export default {
  components: { ODataGrid, QueueDetailsDialog },
  data() {
    return {
      gridData: null,
      limits: [10, 50, 300, 1000],
      offset: 0,
      limit: 10,
      adapterSpec: preProcessSpec({
        idProp: 'name',
        columns: [
          { t: 'Fila', d: 'name', w: 250, sortBy: false },
          { t: 'Veículo|', d: 'vehicleCode', w: 200, sortBy: false },
          {
            t: '',
            code: 'isPaused',
            sortBy: false,
            d: (row) => {
              let paused = row.isPaused
              let ignored = row.isIgnored
              let result = []

              if (paused)
                result.push('<i class="amber v-icon mdi mdi-alpha-p"/>')
              if (ignored)
                result.push('<i class="red v-icon mdi mdi-alpha-i"/>')

              const html = `<span class="pi">${result.join('')}</span>`
              return { value: { html } }
            }
          },
          {
            t: 'Status|',
            sortBy: false,
            d: (r) => {
              let state = (r.worker && r.worker.state) || 'missing'
              let errMessage = r.worker && r.worker.lastWorkerErrorMessage

              if (state == 'stopped' || state == 'errored') {
                errMessage = utils.atMost(errMessage || '(no error msg)', 100)
                return `${state}: ${errMessage}`
              } else {
                return state
              }
            }
          },
          {
            t: 'Act.—Wait.|',
            d: (r) => {
              return `${r.active || 0}—${r.waiting || 0}`
            },
            w: 50,
            sortBy: false
          }
        ]
      }),

      stats: null
    }
  },
  computed: {
    paging() {
      return { limit: this.limit, offset: this.offset }
    }
  },
  watch: {
    paging() {
      this.fetchData()
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    reload() {
      this.fetchData()
    },
    async fetchData() {
      const rows = await go.get('/queues', { includePaused: true })
      const filtered = rows.filter((x) => {
        if (x.clientId == null) return false
        if (!x.clientId.toString().match(/[0-9]+/)) return false
        if (x.isPaused || x.isIgnored) return true
        if ((x.active || 0) + (x.waiting || 0) <= 1 ) return false
        return true
      })

      const opts = { offset: this.offset, limit: this.limit }
      const spec = this.adapterSpec

      this.gridData = grid.generateWebGrid({
        rows: filtered,
        spec,
        count: filtered.length,
        opts
      })
    },
    async showRowDetails(row /*, idx, isMiddle*/) {
      const res = await this.$refs.detailsDialog.open(row.id)

      if (res === 'FLUSH') {
        // await this.flushQueue(row.name)
      } else if (res != null) {
        // await this.restartWorker(res)
      }
    }
  }
}
</script>

<style></style>
